import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { updateDynamicProfileForm, fetchDynamicProfile } from 'services/dynamicProfiles/duck';
import { push } from 'connected-react-router';
import { fetchList as fetchBrandList } from 'services/brands/duck';
import EditForm from 'components/organisms/forms/EditDynamicProfile';

class EditDynamicProfileContainer extends Component {
    componentDidMount() {
        const dynamicProfileId = this.props.match.params.id;

        if (this.props.fetchDynamicProfile && dynamicProfileId) {
            this.props.fetchDynamicProfile({ dynamicProfileId });
        }

        this.props.fetchBrandList();
    }

    render() {
        return (
            <EditForm
                handleSubmit={this.props.handleSubmit.bind(null, updateDynamicProfileForm)}
                dynamicProfile={this.props.dynamicProfile}
                dispatch={this.props.dispatch}
                brands={this.props.brands}
                currentUserScope={this.props.currentUser.scope}
                pristine={this.props.pristine}
                cancel={() => this.props.push('/admin/dynamic-profiles')} >
                {this.props.children}
            </EditForm>
        );
    }
}

const mapStateToProps = state => ({
    dynamicProfile: state.dynamicProfiles.dynamicProfile,
    brands: state.brands.list,
    initialValues: {
        ...state.dynamicProfiles.dynamicProfile
    }
});

export default compose(
    connect(mapStateToProps, { push, fetchDynamicProfile, fetchBrandList }),
    reduxForm({
        form: 'editDynamicProfile',
        enableReinitialize: true,
    })
)(EditDynamicProfileContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/dynamicProfiles/EditDynamicProfileContainer.js